import { render } from "./assessment-v1-question.vue?vue&type=template&id=c78d128a&scoped=true"
import script from "./assessment-v1-question.vue?vue&type=script&lang=js"
export * from "./assessment-v1-question.vue?vue&type=script&lang=js"

import "./assessment-v1-question.vue?vue&type=style&index=0&id=c78d128a&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c78d128a"]])

export default __exports__